// extracted by mini-css-extract-plugin
export default {"strokePurple":"manageTeams_strokePurple__Q8f2G","strokeWhite":"manageTeams_strokeWhite__Z3Tjx"};